import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext({ lang: "tr", setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("zbeach_lang") || "tr");

  useEffect(() => {
    localStorage.setItem("zbeach_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
